import { isModule } from '../helpers/windowLocation';
import { rootHeader } from '../roots';

export function initLegacy() {
	// reference: bynder/includes/js/bynder/helpers/modulehelper.js
	window.bynder?.helpers?.ModuleHelper?.initialize?.();

	// reference: bynder/includes/js/bynder/elements/uploadbutton.js
	// window.bynder?.elements?.UploadButton?.initialize?.();
}

// init new notification center if we are in pybynder
// reference: bynder-frontend/packages/pybynder-frontend/assets/scripts/main.js
export function initLegacyNotifications() {
	window.Bynder?.initNotifications?.();
}

// function initPDFConverter() {
// 	window.app?.Application?.initialize?.();
// }

export function initModalLinks() {
	if (isModule('workflow')) {
		window.Workflow?.initModalLinks?.($('.modal-link'));
	}
}

export function unifiedHeaderOpenModalOnLoad(url: string, dataInit: string) {
	if (isModule('workflow')) {
		window.Workflow?.unifiedHeaderOpenModalOnLoad?.(url, dataInit);
	}
}

export function getLegacyAbilityRules() {
	return window.header?.abilities ?? [];
}

export function initWFModalContainer() {
	if (isModule('workflow')) {
		const modal = $('#briefingroom-modal-container');
		window.Workflow?.initModalContainer?.(modal);
	}
}

interface OpenWFModalProps {
	url: string;
	buttonId: string;
	dataInit?: string;
	dataTitle?: string;
}

export function openWFModal({ url, buttonId, dataInit }: OpenWFModalProps) {
	if (isModule('workflow')) {
		const modal = $('#briefingroom-modal-container');
		const button = $(`#${buttonId}`);

		if (dataInit) {
			button.attr('data-init', dataInit);
		}

		const data = {};
		const options = {
			dataInit,
		};

		window.Workflow?.openModal?.(url, button, data, options, modal);
	}
}

export function getWorkflowData() {
	return (
		window.header?.workflow || {
			visiblePresets: [],
			jobId: '',
			campaignId: '',
			uploadURL: '',
		}
	);
}

export function initCTAMediaUploadButton() {
	window.Workflow?.Job?.initCTAMediaUploadButton?.($('#cta-wf-media-upload'));
}

/**
 * Used to hide elements such as Spotlight and CTA button in PyBynder pages
 */
export function isColdfusion() {
	return document.querySelector(rootHeader)?.getAttribute('data-backend') === 'coldfusion';
}

/*
 *	This function was extracted from toolbarhelper.ts
 *	TODO: Remove _initBrandstoreFeed() from toolbarhelper.js when the unified-header is GE
 */
export function initBrandstoreFeed() {
	const el = document.querySelector('#shoppingCart');

	if (!el) {
		return;
	}

	el.addEventListener('click', () => {
		if (!el.classList.contains('active')) {
			el.classList.add('active');
			document.body.style.overflow = 'hidden';

			const handleClickOutside = (event: MouseEvent) => {
				if (!el.contains(event.target as Node)) {
					el.classList.remove('active');
					document.body.style.overflow = 'visible';
					document.removeEventListener('click', handleClickOutside);
				}
			};
			document.addEventListener('click', handleClickOutside);
		}

		const handleClickOutside = (event: MouseEvent) => {
			if (!el.contains(event.target as Node)) {
				el.classList.remove('active');
				document.removeEventListener('click', handleClickOutside);
			}
		};
		document.addEventListener('click', handleClickOutside);

		const adminOptions = el.closest('.admin-right')?.querySelector('.admin-options');

		if (adminOptions) {
			const handleMouseEnter = () => {
				el.classList.remove('active');
				adminOptions.removeEventListener('mouseenter', handleMouseEnter);
			};
			adminOptions.addEventListener('mouseenter', handleMouseEnter);
		}
	});
}
